export default {
  title: 'Odstrániť dáta hodnôt zákazky',
  confirmDelete: {
    header: 'Potvrdiť odstránenie dát',
    message: 'Potvrďte, že chcete odstrániť hodnoty položky \'{item}\' v rozsahu od {from} do {to}.',
  },
};
